import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ChevronRightFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.22 11.96L9.86 19.32L8.38 17.84L14.26 11.96L8.38 6.08L9.86 4.6L17.22 11.96Z" />
    </SvgIcon>
  );
});
